<div class="bordered mt-2">
  <div *ngIf="isEmpty()" class="test">
    <img src="./assets/images/csv-file-input-icon.svg">
    <div class="inner-drop-container">
      <h3 class="inner-title">Drag and drop a CSV to upload</h3>
      <div class='button-container'>
        <button class="browse-file inner-button">or browser files</button>
        <input type='file' multiple [accept]="accept" (change)="onFileInputChange($event)"
          (click)="onFileInputClick($event)"/>
      </div>
    </div>
  </div>

  <div class="files-group">
    <div class="file" *ngFor="let file of files">
      <input #fileReplace hidden type="file" class="hidden" [accept]="accept" (change)="onReplaceFile(file,$event)"
        (click)="onFileInputClick($event)"/>
      <mat-icon>attach_file</mat-icon>
      <span>{{file.name}}</span>
      <mat-icon class="action-icon" color="accent" [matMenuTriggerFor]="menu">more_vert</mat-icon>
      <mat-menu #menu [class]="'actions'">
        <button *ngIf="!isViewOnly && !file.editBlocked"  mat-menu-item (click)="fileReplace.click()">
          Replace file
        </button>
        <button *ngIf="!isViewOnly && !file.editBlocked" mat-menu-item (click)="onDeleteFile(file)">
          Delete file
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="drop-clue" appDragDrop (fileDropped)="onDragAndDropFile($event)">
    <mat-icon color="accent">backup</mat-icon>
    <p>Drop your files here</p>
  </div>
</div>

<div class="drop-outer mt-3" *ngIf="!isViewOnly">
  <button class="browse-file" (click)="onOpenTemplate()">Show CSV Example</button>
</div>
